import React, { useState } from 'react';
import './ExtendLicenseModal.css';

const RENEWAL_PERIODS = [1, 3, 6, 12, 24, 36];

const ExtendLicenseModal = ({ license, onExtend, onCancel, showAlert }) => {
  const [additionalDays, setAdditionalDays] = useState(360);
  const [submitting, setSubmitting] = useState(false);
  const customerName = license.client_name || license.system_name || license.org_name || '-';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await onExtend(additionalDays);
    } catch (error) {
      if (showAlert) showAlert(`Error: ${error.message}`, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="extend-overlay" onClick={onCancel}>
      <div className="extend-modal" onClick={(e) => e.stopPropagation()}>
        <div className="extend-header">
          <h2>⏰ Extend License</h2>
          <button onClick={onCancel} className="extend-close">
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="extend-form">
          <div className="extend-info">
            <div><strong>Client/System:</strong> {customerName}</div>
            <div><strong>License Key:</strong> <code>{license.license_key}</code></div>
            <div><strong>Current Status:</strong> <span className="extend-status-expired">Expired</span></div>
            {license.expires_at && (
              <div><strong>Expired On:</strong> {new Date(license.expires_at).toLocaleDateString()}</div>
            )}
          </div>

          <div className="extend-field">
            <label className="extend-label">Renewal Period</label>
            <select
              value={additionalDays}
              onChange={(e) => setAdditionalDays(parseInt(e.target.value, 10))}
              className="extend-input"
            >
              {RENEWAL_PERIODS.map((months) => (
                <option key={months} value={months * 30}>
                  {months} month{months > 1 ? 's' : ''}
                </option>
              ))}
            </select>
            <small className="extend-hint">
              New expiry date will be: {new Date(Date.now() + additionalDays * 24 * 60 * 60 * 1000).toLocaleDateString()}
            </small>
          </div>

          <div className="extend-actions">
            <button
              type="button"
              onClick={onCancel}
              disabled={submitting}
              className="extend-btn-cancel"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="extend-btn-submit"
            >
              {submitting ? '⏳ Extending...' : '✅ Extend License'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExtendLicenseModal;
